import { WarnIcon } from "@shared/ui/Icon/ui/history/warn-icon";
import { COMMERCIAL_OK, COMMERCIAL_WARNINGS } from "./constants";
import { ReportCommercialProps } from "./types";
import classes from "./report-commercial.module.scss";

export const ReportCommercial = ({ taxiData, carsharingData, leasing }: ReportCommercialProps) => {
    const hasLeasing = Boolean(leasing);

    return (
        <div className={classes.commercial}>
            <div className={classes.commercial__note}>
                <WarnIcon className={classes["commercial__note--icon"]} /> Если автомобиль
                использовался в коммерческих целях, то он мог подвергаться сильному износу, поэтому
                стоит обратить внимание на его состояние.
            </div>
            {taxiData?.recaps?.map((recap, index) => (
                <div key={`taxi-${index}`} className={classes.commercial__item}>
                    {recap.status === "ok" ? recap.label : COMMERCIAL_WARNINGS.TAXI}
                </div>
            ))}
            {carsharingData?.recaps?.map((recap, index) => (
                <div key={`carsharing-${index}`} className={classes.commercial__item}>
                    {recap.status === "ok" ? recap.label : COMMERCIAL_WARNINGS.CARSHARING}
                </div>
            ))}
            <div className={classes.commercial__item}>
                {hasLeasing ? COMMERCIAL_WARNINGS.LEASING : COMMERCIAL_OK.LEASING}
            </div>
        </div>
    );
};